import { ICustomField } from "@wingspanhq/payments/dist/interfaces";
import { IBulkPayableItem } from "@wingspanhq/payments/dist/interfaces/bulkPayable";
import { ILabelsDictionary } from "./getUploadedFilename";

export const prepareLineItemsFromBulkBatchItem = (
  batchItem: IBulkPayableItem,
  customFields: ICustomField[],
  options?: { includeErrors?: boolean }
) => {
  const customFieldsColumns = customFields.reduce(
    (acc: ILabelsDictionary, cf) => {
      acc[cf.key] = batchItem.labels[cf.key];
      return acc;
    },
    {}
  );
  return {
    email: batchItem.collaboratorEmail,
    contractorId: batchItem.collaboratorExternalId,
    collaboratorId: batchItem.collaboratorId,
    amount: batchItem.amount,
    lineItemTitle: batchItem.lineItemDescription,
    lineItemDescription: batchItem.lineItemDetail,
    dueDate: batchItem.dueDate,
    reimbursable: batchItem.reimbursableExpense,
    invoiceNotes: batchItem.payableNotes,
    attachmentId: batchItem.attachmentId,
    paymentRefId: batchItem.bulkPayableItemReference,
    paidDate: batchItem.paidDate,
    invoiceDate: batchItem.invoiceDate,
    ...customFieldsColumns,
    ...(options?.includeErrors
      ? { error: batchItem.metadata?.errorMessage }
      : {})
  };
};
